import type { IconSvgObject } from './types';

const BrickWallIcon: IconSvgObject = [
  ["path", { d: "M3 19V5C3 3.89543 3.89543 3 5 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12 9H3H7.5M12 9V15M12 9H21H16.5M12 15H3H7.5M12 15H21H16.5M7.5 3V9M7.5 9H16.5M16.5 3V9M7.5 15V21M7.5 15H16.5M16.5 15V21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default BrickWallIcon;
